import { combineReducers } from "redux";

import menu from "./menu";
import auth from "./auth";

const reducers = combineReducers({ menu, auth });

export default reducers;
